/* -disable radix */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Filter from '../Filter';
import Dropdown from './Dropdown';

import './styles.css';

class Filters extends Component {
  render() {
    const {
      isOpen,
      onClick,
      onFilter,
      options,
      submitText,
      placeholder,
      current,
      type,
      dropdownLabel,
      filterLabel,
    } = this.props;

    return (
      <Filter label={filterLabel} isOpen={isOpen} onClick={onClick}>
        <Dropdown
          type={type}
          placeholder={placeholder}
          submitText={submitText}
          options={options}
          initialSelectedValues={
            current && Array.isArray(current)
              ? current.map(value => parseInt(value))
              : []
          }
          initialStringValue={
            current && typeof current === 'string' && current !== ''
              ? current
              : moment().toDate()
          }
          onFilter={onFilter}
          dropdownLabel={dropdownLabel}
        />
      </Filter>
    );
  }
}

Filters.propTypes = {
  onFilter: PropTypes.func.isRequired,
};

export default Filters;
